// extracted by mini-css-extract-plugin
export default {"bannersContainer":"styles_bannersContainer__pzG7u","header":"styles_header__e6s28","loader":"styles_loader__zY1lp","dragContainer":"styles_dragContainer__QnUL4"};